export default "<div>this is the standings component, test</div>";